const creditResume = {
  'credit-resume-current-statement': 'Statement balance',
  'credit-resume-current-statement-due-date': 'Payment due date ',
  'credit-resume-next-statement': 'Next statement balance',
  'credit-resume-next-statement-due-date': 'Payment due date ',
  'credit-resume-transfer': 'Transfer',
};

export default creditResume;
